import type { DateRange } from './components/StatelessComponent/SingleFilter/DateRangeFilter/DateRangeFilterType';
import type { GlobalFilter } from './domains/global-filters/model/FilterChain';
import type { QueryFormatFilter } from './domains/global-filters/model/QueryFormat';
import {
  DATE_RANGE_TYPE,
  DATE_UNITS,
} from './components/StatelessComponent/SingleFilter/DateRangeFilter/DateRangeFilterType';
import { convertFromNewUiToQueryFormat } from './utils/FormatConverter/FilterConverterFromUiToQuery';

export const getDefaultDateRange = (): DateRange => {
  return {
    type: DATE_RANGE_TYPE.RELATIVE,
    amount: 30,
    unit: DATE_UNITS.DAYS,
  };
};

export const getDefaultFilterInUiFormat = (): GlobalFilter => {
  return {
    dateRange: getDefaultDateRange(),
    filterList: [],
  };
};

export const getDefaultFilterInQueryFormat = (): QueryFormatFilter => {
  return convertFromNewUiToQueryFormat(getDefaultFilterInUiFormat());
};
